import {
  Button,
  createTableColumn, DataGrid,
  DataGridBody, DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
  Menu, MenuItem, MenuList, MenuPopover, MenuTrigger,
  TableColumnDefinition
} from '@fluentui/react-components';
import { DeleteRegular, MoreHorizontalFilled, ArrowDownRegular, EditRegular, ArrowUpRegular } from '@fluentui/react-icons';
import React from "react";
import { IntlShape, useIntl } from "react-intl";

import { IAppFeaturesDataGrid as ITableItems } from "./IAppFeaturesDataGrid"


export const AppFeaturesDataGrid: React.FC<{
  onMoveUp: (index: number) => void,
  onMoveDown: (index: number) => void,
  onDelete: (index: number) => void,
  onEditDailogOpen: (item: number) => void,
  items: ITableItems[]
}> = ({ items, onMoveUp, onMoveDown, onDelete, onEditDailogOpen }) => {

  const intl = useIntl();

  const columns: TableColumnDefinition<ITableItems>[] = [
    createTableColumn<ITableItems>({
      columnId: "name",
      renderHeaderCell: () => intl.formatMessage({ defaultMessage: "Name" }),
      renderCell: (data) => (<>
        {getString(intl, data.name)}
      </>)
    }),
    createTableColumn<ITableItems>({
      columnId: "url",
      renderHeaderCell: () => intl.formatMessage({ defaultMessage: "URL" }),
      renderCell: (data) => data.contentUrl
    }),
    createTableColumn<ITableItems>({
      columnId: "scope",
      renderHeaderCell: () => intl.formatMessage({ defaultMessage: "Scope" }),
      renderCell: (data) => data.scopes?.toString() ?? "-"
    }),
    createTableColumn<ITableItems>({
      columnId: "action",
      renderHeaderCell: () => intl.formatMessage({ defaultMessage: "Action" }),
      renderCell: (data) => <Elipsis item={data} />
    }),
  ]

  const Elipsis: React.FC<{ item: ITableItems; }> = ({ item }) => {
    return (
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button icon={<MoreHorizontalFilled />} appearance="transparent" />
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem disabled={!canAction(item.name!)} icon={<EditRegular />} onClick={() => { onEditDailogOpen(item.index) }}>
              {intl.formatMessage({ defaultMessage: "Edit" })}
            </MenuItem>
            <MenuItem icon={<ArrowUpRegular />} onClick={() => { onMoveUp(item.index) }}>
              {intl.formatMessage({ defaultMessage: "Up" })}
            </MenuItem>
            <MenuItem icon={<ArrowDownRegular />} onClick={() => { onMoveDown(item.index) }}>
              {intl.formatMessage({ defaultMessage: "Down" })}
            </MenuItem>
            <MenuItem disabled={!canAction(item.name!)} icon={<DeleteRegular />} onClick={() => { onDelete(item.index) }}>
              {intl.formatMessage({ defaultMessage: "Delete" })}
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    )
  }

  return (
    <DataGrid items={items} columns={columns} focusMode="composite">
      <DataGridHeader>
        <DataGridRow>
          {({ renderHeaderCell }) => <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>}
        </DataGridRow>
      </DataGridHeader>
      <DataGridBody<ITableItems>>
        {({ item, rowId }) => (
          <DataGridRow<ITableItems> key={rowId}>
            {({ renderCell }) => <DataGridCell>{renderCell(item)}</DataGridCell>}
          </DataGridRow>
        )}
      </DataGridBody>
    </DataGrid>
  )
}

const getString = (intl: IntlShape, str: string | null) => {
  switch (str) {
    case "conversations":
      return intl.formatMessage({ defaultMessage: "Chat" });
    case "about":
      return intl.formatMessage({ defaultMessage: "About" });
    default:
      return str ?? "-";
  }
}

const canAction = (str: string) => {
  return str !== "about" && str !== "conversations";
}
